/* currency string need to conform to ISO 4217 */
export const ISO_4217_CURRENCY_CODES = [
    //'AED',
    //'AFN',
    //'ALL',
    //'AMD',
    //'ANG',
    //'AOA',
    //'ARS',
    'AUD',
    //'AWG',
    //'AZN',
    //'BAM',
    //'BBD',
    //'BDT',
    'BGN',
    //'BHD',
    //'BIF',
    //'BMD',
    //'BND',
    //'BOB',
    //'BOV',
    'BRL',
    //'BSD',
    //'BTN',
    //'BWP',
    //'BYN',
    //'BYR',
    //'BZD',
    'CAD',
    //'CDF',
    //'CHE',
    'CHF',
    //'CHW',
    //'CLF',
    //'CLP',
    'CNY',
    //'COP',
    //'COU',
    //'CRC',
    //'CUC',
    //'CUP',
    //'CVE',
    'CZK',
    //'DJF',
    'DKK',
    //'DOP',
    //'DZD',
    //'EGP',
    //'ERN',
    //'ETB',
    'EUR',
    //'FJD',
    //'FKP',
    'GBP',
    //'GEL',
    //'GHS',
    //'GIP',
    //'GMD',
    //'GNF',
    //'GTQ',
    //'GYD',
    'HKD',
    //'HNL',
    'HRK',
    //'HTG',
    'HUF',
    'IDR',
    'ILS',
    'INR',
    //'IQD',
    //'IRR',
    'ISK',
    //'JMD',
    //'JOD',
    'JPY',
    //'KES',
    //'KGS',
    //'KHR',
    //'KMF',
    //'KPW',
    'KRW',
    //'KWD',
    //'KYD',
    //'KZT',
    //'LAK',
    //'LBP',
    //'LKR',
    //'LRD',
    //'LSL',
    //'LYD',
    //'MAD',
    //'MDL',
    //'MGA',
    //'MKD',
    //'MMK',
    //'MNT',
    //'MOP',
    //'MRU',
    //'MUR',
    //'MVR',
    //'MWK',
    'MXN',
    //'MXV',
    'MYR',
    //'MZN',
    //'NAD',
    //'NGN',
    //'NIO',
    'NOK',
    //'NPR',
    'NZD',
    //'OMR',
    //'PAB',
    //'PEN',
    //'PGK',
    'PHP',
    //'PKR',
    'PLN',
    //'PYG',
    //'QAR',
    'RON',
    //'RSD',
    'RUB',
    //'RWF',
    //'SAR',
    //'SBD',
    //'SCR',
    //'SDG',
    'SEK',
    'SGD',
    //'SHP',
    //'SLL',
    //'SOS',
    //'SRD',
    //'SSP',
    //'STN',
    //'SVC',
    //'SYP',
    //'SZL',
    'THB',
    //'TJS',
    //'TMT',
    //'TND',
    //'TOP',
    'TRY',
    //'TTD',
    //'TWD',
    //'TZS',
    //'UAH',
    //'UGX',
    'USD',
    //'UYI',
    //'UYU',
    //'UZS',
    //'VEF',
    //'VND',
    //'VUV',
    //'WST',
    //'XAF',
    //'XCD',
    //'XOF',
    //'XPF',
    //'XSU',
    //'YER',
    'ZAR',
    //'ZMW',
    //'ZWL',
];



// WEBPACK FOOTER //
// ./src/utility/Currencies.ts